import axios from "axios";

export const campaignsApi = axios.create({
  baseURL: `${process.env.VUE_APP_URL}/api/patients/careProgram/campaigns`,
});
